import React, { useEffect, useState } from "react";
import api from "services/api";
import { CSSTransition } from "react-transition-group";
import LandingPageType1 from "./LandingPageType1";
import LandingPageType2 from "./LandingPageType2";
import "./LandingPage.css";

const LandingPage = ({ landingPageId, onNext }) => {
  const [landingPage, setLandingPage] = useState(null);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const fetchLandingPage = async () => {
      try {
        setShowContent(false);
        const response = await api.get(
          `/funnel-landing-pages/${landingPageId}/`
        );
        setLandingPage(response.data);
        setTimeout(() => {
          setShowContent(true);
        }, 50);
      } catch (error) {
        console.error("Error fetching landing page:", error);
      }
    };

    fetchLandingPage();
  }, [landingPageId]);

  if (!landingPage) {
    return null;
  }

  const renderContent = () => {
    if (landingPage.page_type === "type1") {
      return <LandingPageType1 landingPage={landingPage} onNext={onNext} />;
    } else if (landingPage.page_type === "type2") {
      return <LandingPageType2 landingPage={landingPage} onNext={onNext} />;
    } else {
      return <LandingPageType1 landingPage={landingPage} onNext={onNext} />;
    }
  };

  return (
    <div className="landing-container">
      <CSSTransition
        in={showContent}
        timeout={500}
        classNames="fade"
        unmountOnExit
        appear={true}
      >
        <div className="landing-content">{renderContent()}</div>
      </CSSTransition>
    </div>
  );
};

export default LandingPage;
